<template>
  <div
    v-if="layout === 'stacked'"
    class="mx-auto max-w-[650px] px-28 pb-40 pt-24"
  >
    <ShoppingAssistantButton
      v-if="isShoppingAssistantWebEnabled"
      @click="emit('search-with-ai')"
    />
    <slot name="main" />
  </div>

  <div
    v-else
    class="grid grid-cols-1 gap-x-16 pt-24 items-start md:grid-cols-[256px_auto] md:grid-rows-[auto_1fr]"
  >
    <ShoppingAssistantButton
      v-if="isShoppingAssistantWebEnabled"
      class="px-24 md:pl-40 md:pr-0"
      @click="emit('search-with-ai')"
    />

    <div class="min-w-0 px-24 md:col-start-2 md:row-span-full md:px-0">
      <slot name="main" />
    </div>

    <div class="mt-16 min-w-0 px-24 md:mt-0 md:pl-40 md:pr-0 md:pb-40">
      <slot name="aside" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useIsShoppingAssistantWebEnabled } from '~/scopes/shopping-assistant/composables/useIsShoppingAssistantWebEnabled'

import ShoppingAssistantButton from '../ShoppingAssistantButton/ShoppingAssistantButton.vue'

withDefaults(
  defineProps<{
    layout?: 'columns' | 'stacked'
  }>(),
  { layout: 'columns' },
)

const emit = defineEmits<{ 'search-with-ai': [] }>()

const isShoppingAssistantWebEnabled = useIsShoppingAssistantWebEnabled()
</script>
